/**
 * JWT-User aus `localStorage` (`user`), plus In-Memory-Cache.
 * Der Axios-Interceptor bleibt synchron. Native Keychain kommt später
 * in denselben Zugriffspfad — Web-Zweig bleibt exakt localStorage.
 */

const USER_KEY = 'user';

let memoryUser;
let hydrated = false;

function readFromLocalStorage() {
    try {
        return JSON.parse(localStorage.getItem(USER_KEY) || 'null');
    } catch (err) {
        return null;
    }
}

export function getUser() {
    if (!hydrated) {
        memoryUser = readFromLocalStorage();
        hydrated = true;
    }
    return memoryUser;
}

export function getToken() {
    return getUser()?.token || null;
}

export function hasUserSession() {
    try {
        return !!localStorage.getItem(USER_KEY);
    } catch (err) {
        return false;
    }
}

export function setUser(user) {
    memoryUser = user;
    hydrated = true;
    if (user == null) {
        localStorage.removeItem(USER_KEY);
        return;
    }
    localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function updateToken(newToken) {
    const user = getUser();
    if (!user?.token) {
        return;
    }
    setUser({ ...user, token: newToken });
}

export function clearUser() {
    setUser(null);
}
